export const format = (string = '', options = {}, match = (key) => key) => {
  return Object.keys(options).reduce((result, key) => {
    const searchValue = match(key);
    const replaceValue = options[key];

    return result.replaceAll(searchValue, replaceValue);
  }, string);
};

export const formatCMSContent = (string = '', options = {}) => {
  const match = (key) => new RegExp(`\\[\\[\\s?${key}\\s?]]`, 'g');
  return format(string, options, match);
};

export const formatAPIUrl = (string = '', options = {}) => {
  const defaultOptions = {
    ':protocol': window.location.protocol,
    ':hostname': window.location.hostname,
  };

  return format(string, { ...defaultOptions, ...options });
};
